export const environment = {
  "API_DOMAIN": "https://api.leangroup.com",
  "API_PATH_PREFIX": "rest",
  "GOOGLE_API": "AIzaSyAEIQELVtyPGxmJ8abFrwxGYXrFMXaY4bM",
  "PORTAL": "employees",
  "PUSHER_CLUSTER": "mt1",
  "PUSHER_KEY": "3ae403499a3441c4ea15",
  "TAG_MANAGER": "GTM-PH93MT9",
  "URL_DOMAIN": "leangroup.com",
  "URL_LOGIN": "https://portal.leangroup.com/",
  "firebaseConfig": {
    "apiKey": "AIzaSyCYNOVttzYifo78QtVoNhbNvLrABMNf6vg",
    "appId": "1:1087475455739:web:3abc21568034ffe2b7025e",
    "authDomain": "lsg-deployments.firebaseapp.com",
    "measurementId": "G-WKL4CCDSJG",
    "messagingSenderId": "1087475455739",
    "projectId": "lsg-deployments",
    "storageBucket": "lsg-deployments.appspot.com"
  },
  "logRocket": "lean-staffing/employees",
  "production": true
};
